import React from "react";
import { observer } from "mobx-react-lite";
import { Modal } from "react-bootstrap";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import ApproveToolbox from "../../common/approval/approveToolbox";
import type { ViewComponent } from "@frui.ts/views/dist";
import { View } from "@frui.ts/views/dist";
import type RefundDetailViewModel from "viewModels/finance/refundApprovals/detail/refundDetailViewModel";
import type { IRefund } from "entities/types";
import { isValidForApproval } from "utils/approvable";
import PrevNextNavigationHeader from "../../common/prevNextNavigationHeader";

const RefundDetailView: ViewComponent<RefundDetailViewModel<any, any>> = observer(({ vm, children }) => (
  <Modal scrollable show={true} onHide={vm.requestClose} centered dialogClassName="modal-90w">
    <Modal.Header closeButton={true}>
      {!vm.isInitialized || !vm.item ? (
        <div style={{ minHeight: "100px" }}></div>
      ) : (
        <div className="d-flex align-items-center">
          <PrevNextNavigationHeader vm={vm} />
          <div className="col-12 col-lg-auto ml-auto">
            {isValidForApproval(vm.item) && (
              <ApproveToolbox<IRefund>
                approval={vm.item}
                translate={vm.translate}
                approve={vm.onApproveClick}
                canApprove={vm.canApprove}
                disabled={!vm.allowApprove}
                myApprovalStep={vm.myApprovalStep}
                approvedByMe={vm.approvedByMe}
                isExported={vm.isExported}
                rejectionReason={vm.item?.permittedActions?.approval.rejectionReason}
              />
            )}
          </div>
        </div>
      )}
    </Modal.Header>
    <Modal.Body>
      <LoaderOverlay loading={vm.busyWatcher.isBusy} style={{ minHeight: 100 }}>
        <View vm={vm.alertsViewModel} useLifecycle />
        {vm.isInitialized && vm.item && children}
      </LoaderOverlay>
    </Modal.Body>
  </Modal>
));

export default RefundDetailView;
